import { useMemo } from 'react';
import { GroupLevel } from 'src/domain';
import { usePartners } from './usePartners';

export const useDefaultPartner = (type: GroupLevel) => {
    const { partners } = usePartners(type);

    return useMemo(() => (partners && partners.length === 1 ? partners.first() : null), [partners]);
};
